'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'handshake';
var width = 576;
var height = 512;
var aliases = [129309,62662,"handshake-alt","handshake-simple"];
var unicode = 'f2b5';
var svgPathData = ['M16 62l86.6 63c6.4 4.6 15.2 3.9 20.7-1.6l3.9-3.9c15-15 35.4-23.4 56.6-23.4L249.4 96 144 201.4c-12.5 12.5-12.5 32.8 0 45.3l.8 .8c43.7 43.7 114.7 43.7 158.4 0L336 214.6 439.4 318.1c18.7 18.7 18.7 49.1 0 67.9l-19.4 19.4-32.7-32.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L396.3 427c-18.9 13.6-41.8 21-65.4 21l-12.4 0-43.3-43.3c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l20.7 20.7-28.4 0c-29.7 0-58.2-11.8-79.2-32.8L27.3 276.7c-3.1-3.1-7.2-4.7-11.3-4.7L16 62zM166.6 224l128-128 92.3 0c15.8 0 31.2 4.7 44.4 13.4l23.8 15.9c5.6 3.7 12.9 3.6 18.3-.4l86.6-63 0 210c-4.1 0-8.2 1.6-11.3 4.7l-64 64c-2.4-16.6-9.9-32.5-22.6-45.3L347.3 180.7c-6.2-6.2-16.4-6.2-22.6 0l-44.1 44.1c-31.2 31.2-81.9 31.2-113.1 0l-.8-.8z', 'M561.4 60.9c7.1-5.2 8.7-15.2 3.5-22.4s-15.2-8.7-22.4-3.5l-79 57.4-14.5-9.7C430.7 70.5 409 64 386.9 64L183.8 64c-26.9 0-52.9 9.7-73.2 27.2L33.4 35.1c-7.1-5.2-17.2-3.6-22.4 3.5S7.4 55.7 14.6 60.9l88 64c6.4 4.6 15.2 3.9 20.7-1.6l3.9-3.9c15-15 35.4-23.4 56.6-23.4L249.4 96 144 201.4c-12.5 12.5-12.5 32.8 0 45.3l.8 .8c43.7 43.7 114.7 43.7 158.4 0L336 214.6 439.4 318.1c18.7 18.7 18.7 49.1 0 67.9l-19.4 19.4-32.7-32.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L396.3 427c-18.9 13.6-41.8 21-65.4 21l-12.4 0-43.3-43.3c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l20.7 20.7-28.4 0c-29.7 0-58.2-11.8-79.2-32.8L27.3 276.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L143.2 437.8c27 27 63.6 42.2 101.8 42.2l86 0c38.2 0 74.8-15.2 101.8-42.2l29.3-29.3c1.2-1.2 2.4-2.5 3.5-3.8 .6-.5 1.2-1 1.7-1.5l104-104c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-2.4-16.6-9.9-32.5-22.6-45.3L347.3 180.7c-6.2-6.2-16.4-6.2-22.6 0l-44.1 44.1c-31.2 31.2-81.9 31.2-113.1 0l-.8-.8 128-128 92.3 0c15.8 0 31.2 4.7 44.4 13.4l23.8 15.9c5.6 3.7 12.9 3.6 18.3-.4l88-64z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHandshake = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;